import { SimpleStore } from "@core/store/store";
import { Filter } from "./filter";
import { FilterApi } from "./filterApi";

export class FilterService {
	filterStore = new SimpleStore((id) => this.filterApi.fetch(id));
	filterByUserSlugStore = new SimpleStore((userSlug) => this.filterApi.fetchByUserSlug(userSlug));
	// myFilterStore = new StorePresentation(this.filterStore, (page, query?: string, type?: AssetType) =>
	// 	this.filterApi.list(page, query, type)
	// );
	constructor(private readonly filterApi: FilterApi) {}

	async list(): Promise<Filter[]> {
		return this.filterApi.list();
	}
}
